import { Directive, ElementRef, Injector, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSelect } from '@angular/material/select';
import { ActivatedRoute, Router } from '@angular/router';
import { CrudDataSource, CrudListComponent, FormStorage, UserStorage } from '@scisys-uim/uim-common';
import { ASSET_MAINTENANCE_TYPE, AssetMaintenance, AssetsUser, RefCode } from 'assets-model';
import { AssetMaintenanceDataSource, AssetMaintenanceService, RefCodeStorage } from 'assets-service';


@Directive()
export abstract class AssetMaintenanceSearchComponentBase extends CrudListComponent<AssetMaintenance, number> {
  protected systemConfig: any;

  displayedColumns: string[] = [ 'assetMaintenanceId', 'assetId', 'comments', 'createdBy', 'createdDate', 'lockVersion', 'maintenanceBy', 'maintenanceDate', 'maintenanceType', 'actions'];

  public searchForm: FormGroup;

  assetMaintenanceIdFilter: number;
  @ViewChild('assetMaintenanceIdFilterInput') assetMaintenanceIdFilterInput: ElementRef;

  assetIdFilter: number;
  @ViewChild('assetIdFilterInput') assetIdFilterInput: ElementRef;
  assetIdLessThanFilter: number;
  @ViewChild('assetIdLessThanFilterInput') assetIdLessThanFilterInput: ElementRef;
  assetIdLessThanOrEqualToFilter: number;
  @ViewChild('assetIdLessThanOrEqualToFilterInput') assetIdLessThanOrEqualToFilterInput: ElementRef;
  assetIdGreaterThanFilter: number;
  @ViewChild('assetIdGreaterThanFilterInput') assetIdGreaterThanFilterInput: ElementRef;
  assetIdGreaterThanOrEqualToFilter: number;
  @ViewChild('assetIdGreaterThanOrEqualToFilterInput') assetIdGreaterThanOrEqualToFilterInput: ElementRef;

  commentsFilter: string;
  @ViewChild('commentsFilterInput') commentsFilterInput: ElementRef;

  createdByFilter: string;
  @ViewChild('createdByFilterInput') createdByFilterInput: ElementRef;

  createdDateFilter: Date;
  @ViewChild('createdDateFilterInput') createdDateFilterInput: ElementRef;
  createdDateLessThanFilter: Date;
  @ViewChild('createdDateLessThanFilterInput') createdDateLessThanFilterInput: ElementRef;
  createdDateLessThanOrEqualToFilter: Date;
  @ViewChild('createdDateLessThanOrEqualToFilterInput') createdDateLessThanOrEqualToFilterInput: ElementRef;
  createdDateGreaterThanFilter: Date;
  @ViewChild('createdDateGreaterThanFilterInput') createdDateGreaterThanFilterInput: ElementRef;
  createdDateGreaterThanOrEqualToFilter: Date;
  @ViewChild('createdDateGreaterThanOrEqualToFilterInput') createdDateGreaterThanOrEqualToFilterInput: ElementRef;

  maintenanceByFilter: string;
  @ViewChild('maintenanceByFilterInput') maintenanceByFilterInput: ElementRef;

  maintenanceDateFilter: Date;
  @ViewChild('maintenanceDateFilterInput') maintenanceDateFilterInput: ElementRef;
  maintenanceDateLessThanFilter: Date;
  @ViewChild('maintenanceDateLessThanFilterInput') maintenanceDateLessThanFilterInput: ElementRef;
  maintenanceDateLessThanOrEqualToFilter: Date;
  @ViewChild('maintenanceDateLessThanOrEqualToFilterInput') maintenanceDateLessThanOrEqualToFilterInput: ElementRef;
  maintenanceDateGreaterThanFilter: Date;
  @ViewChild('maintenanceDateGreaterThanFilterInput') maintenanceDateGreaterThanFilterInput: ElementRef;
  maintenanceDateGreaterThanOrEqualToFilter: Date;
  @ViewChild('maintenanceDateGreaterThanOrEqualToFilterInput') maintenanceDateGreaterThanOrEqualToFilterInput: ElementRef;

  maintenanceTypeSelectionList: RefCode[];
  maintenanceTypeFilter: string;
  @ViewChild('maintenanceTypeFilterInput') maintenanceTypeFilterInput: MatSelect;


  get eAssetsUser(): AssetsUser {
    return AssetsUser.assignAs(this.userDetails);
  }

  constructor(protected route: ActivatedRoute,
    protected router: Router,
    protected userStorage: UserStorage,
    protected dialog: MatDialog,
    protected assetMaintenanceService: AssetMaintenanceService,
    protected refCodeStorage: RefCodeStorage,
    protected fb: FormBuilder,
    protected formStorage: FormStorage,
    protected injector: Injector) {
    super(ASSET_MAINTENANCE_TYPE, route, router, userStorage, dialog, assetMaintenanceService, injector);

    this.searchForm = this.fb.group({
      assetMaintenanceId: [null],
      assetIdLessThan: [null],
      assetIdLessThanOrEqualTo: [null],
      assetIdGreaterThan: [null],
      assetIdGreaterThanOrEqualTo: [null],
      assetId: [null],
      comments: [null],
      createdBy: [null],
      createdDateLessThan: [null],
      createdDateLessThanOrEqualTo: [null],
      createdDateGreaterThan: [null],
      createdDateGreaterThanOrEqualTo: [null],
      createdDate: [null],
      maintenanceBy: [null],
      maintenanceDateLessThan: [null],
      maintenanceDateLessThanOrEqualTo: [null],
      maintenanceDateGreaterThan: [null],
      maintenanceDateGreaterThanOrEqualTo: [null],
      maintenanceDate: [null],
      maintenanceType: [null]
    });
  }

  createDataSource(): CrudDataSource<AssetMaintenance> {
    return new AssetMaintenanceDataSource(this.assetMaintenanceService);
  }

  createServiceArguments(): any {
    return {
      assetMaintenanceId: this.assetMaintenanceIdFilter,
      assetIdLessThan: this.assetIdLessThanFilter,
      assetIdLessThanOrEqualTo: this.assetIdLessThanOrEqualToFilter,
      assetIdGreaterThan: this.assetIdGreaterThanFilter,
      assetIdGreaterThanOrEqualTo: this.assetIdGreaterThanOrEqualToFilter,
      assetId: this.assetIdFilter,
      comments: this.commentsFilter,
      createdBy: this.createdByFilter,
      createdDateLessThan: this.createdDateLessThanFilter,
      createdDateLessThanOrEqualTo: this.createdDateLessThanOrEqualToFilter,
      createdDateGreaterThan: this.createdDateGreaterThanFilter,
      createdDateGreaterThanOrEqualTo: this.createdDateGreaterThanOrEqualToFilter,
      createdDate: this.createdDateFilter,
      maintenanceBy: this.maintenanceByFilter,
      maintenanceDateLessThan: this.maintenanceDateLessThanFilter,
      maintenanceDateLessThanOrEqualTo: this.maintenanceDateLessThanOrEqualToFilter,
      maintenanceDateGreaterThan: this.maintenanceDateGreaterThanFilter,
      maintenanceDateGreaterThanOrEqualTo: this.maintenanceDateGreaterThanOrEqualToFilter,
      maintenanceDate: this.maintenanceDateFilter,
      maintenanceType: this.maintenanceTypeFilter
    };
  }
  
  clearFiltersBeforeLoadPage() {
    this.restoreFormFromParams(this.searchForm);
  }
  
  clearFilterVariables() {
    this.assetMaintenanceIdFilter = null;
    this.assetIdLessThanFilter = null;
    this.assetIdLessThanOrEqualToFilter = null;
    this.assetIdGreaterThanFilter = null;
    this.assetIdGreaterThanOrEqualToFilter = null;
    this.assetIdFilter = null;
    this.commentsFilter = null;
    this.createdByFilter = null;
    this.createdDateLessThanFilter = null;
    this.createdDateLessThanOrEqualToFilter = null;
    this.createdDateGreaterThanFilter = null;
    this.createdDateGreaterThanOrEqualToFilter = null;
    this.createdDateFilter = null;
    this.maintenanceByFilter = null;
    this.maintenanceDateLessThanFilter = null;
    this.maintenanceDateLessThanOrEqualToFilter = null;
    this.maintenanceDateGreaterThanFilter = null;
    this.maintenanceDateGreaterThanOrEqualToFilter = null;
    this.maintenanceDateFilter = null;
    this.maintenanceTypeFilter = null;
  }
  
  clearFilters() {
    this.clearFilterVariables();
    this.clearFiltersBeforeLoadPage();
    this.loadPage();
  }

  ngAfterViewInit(): void {
    super.ngAfterViewInit();
    this.addSearchOnChangedInputEventListener(this.assetMaintenanceIdFilterInput);
    this.addSearchOnChangedInputEventListener(this.assetIdLessThanFilterInput);
    this.addSearchOnChangedInputEventListener(this.assetIdLessThanOrEqualToFilterInput);
    this.addSearchOnChangedInputEventListener(this.assetIdGreaterThanFilterInput);
    this.addSearchOnChangedInputEventListener(this.assetIdGreaterThanOrEqualToFilterInput);
    this.addSearchOnChangedInputEventListener(this.assetIdFilterInput);
    this.addSearchOnChangedInputEventListener(this.commentsFilterInput);
    this.addSearchOnChangedInputEventListener(this.createdByFilterInput);
    this.addSearchOnChangedInputEventListener(this.createdDateLessThanFilterInput);
    this.addSearchOnChangedInputEventListener(this.createdDateLessThanOrEqualToFilterInput);
    this.addSearchOnChangedInputEventListener(this.createdDateGreaterThanFilterInput);
    this.addSearchOnChangedInputEventListener(this.createdDateGreaterThanOrEqualToFilterInput);
    this.addSearchOnChangedInputEventListener(this.createdDateFilterInput);
    this.addSearchOnChangedInputEventListener(this.maintenanceByFilterInput);
    this.addSearchOnChangedInputEventListener(this.maintenanceDateLessThanFilterInput);
    this.addSearchOnChangedInputEventListener(this.maintenanceDateLessThanOrEqualToFilterInput);
    this.addSearchOnChangedInputEventListener(this.maintenanceDateGreaterThanFilterInput);
    this.addSearchOnChangedInputEventListener(this.maintenanceDateGreaterThanOrEqualToFilterInput);
    this.addSearchOnChangedInputEventListener(this.maintenanceDateFilterInput);
    this.addSearchOnChangedSelectEventListener(this.maintenanceTypeFilterInput);
    this.formStorage.rememberFormChanges(this.searchForm);
  }

  ngOnInit() {
    super.ngOnInit();
  }
  
  protected onInitAsyncComplete() {
    super.onInitAsyncComplete();
  }

  protected initExportOptions(config: any): any {
    config = config || {};
    return config;
  }

  protected initConfig(config: any) {
    super.initConfig(config);
    this.systemConfig = this.initExportOptions(config);
  }
  
  protected transformAllPropertiesToModelSetters(): {
    [key: string]: (value: any, formControl: FormControl, formControlName: string) => void
  } {
    const self = this;
    return {
      assetMaintenanceId: (value: number) => self.assetMaintenanceIdFilter = value,
      assetIdLessThan: (value: number) => self.assetIdLessThanFilter = value,
      assetIdLessThanOrEqualTo: (value: number) => self.assetIdLessThanOrEqualToFilter = value,
      assetIdGreaterThan: (value: number) => self.assetIdGreaterThanFilter = value,
      assetIdGreaterThanOrEqualTo: (value: number) => self.assetIdGreaterThanOrEqualToFilter = value,
      assetId: (value: number) => self.assetIdFilter = value,
      comments: (value: string) => self.commentsFilter = value,
      createdBy: (value: string) => self.createdByFilter = value,
      createdDateLessThan: (value: Date) => self.createdDateLessThanFilter = value,
      createdDateLessThanOrEqualTo: (value: Date) => self.createdDateLessThanOrEqualToFilter = value,
      createdDateGreaterThan: (value: Date) => self.createdDateGreaterThanFilter = value,
      createdDateGreaterThanOrEqualTo: (value: Date) => self.createdDateGreaterThanOrEqualToFilter = value,
      createdDate: (value: Date) => self.createdDateFilter = value,
      maintenanceBy: (value: string) => self.maintenanceByFilter = value,
      maintenanceDateLessThan: (value: Date) => self.maintenanceDateLessThanFilter = value,
      maintenanceDateLessThanOrEqualTo: (value: Date) => self.maintenanceDateLessThanOrEqualToFilter = value,
      maintenanceDateGreaterThan: (value: Date) => self.maintenanceDateGreaterThanFilter = value,
      maintenanceDateGreaterThanOrEqualTo: (value: Date) => self.maintenanceDateGreaterThanOrEqualToFilter = value,
      maintenanceDate: (value: Date) => self.maintenanceDateFilter = value,
      maintenanceType: (value: string) => self.maintenanceTypeFilter = value
    }
  }
  
  restoreFormChanges() {
    const self = this;

    // IMPORTANT that the restoreFormChanges call occurs before the initial search - typically best done in onInitAsyncComplete
    // Whereever a form control binds with [ngModel] to a reactive form, ngModel takes precedence,
    // and needs it's own setter function to set the scope attribute bound
    this.formStorage.restoreFormChanges(this.searchForm, this.transformAllPropertiesToModelSetters());
  }

  assetMaintenanceIdChanging(value: number, unsetDependents: boolean = true) {}
  
  assetMaintenanceIdChanged(value: number, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  assetIdChanging(value: number, unsetDependents: boolean = true) {}
  
  assetIdChanged(value: number, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  assetIdLessThanChanging(value: number, unsetDependents: boolean = true) {}
  
  assetIdLessThanChanged(value: number, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  assetIdLessThanOrEqualToChanging(value: number, unsetDependents: boolean = true) {}
  
  assetIdLessThanOrEqualToChanged(value: number, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  assetIdGreaterThanChanging(value: number, unsetDependents: boolean = true) {}
  
  assetIdGreaterThanChanged(value: number, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  assetIdGreaterThanOrEqualToChanging(value: number, unsetDependents: boolean = true) {}
  
  assetIdGreaterThanOrEqualToChanged(value: number, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  commentsChanging(value: string, unsetDependents: boolean = true) {}
  
  commentsChanged(value: string, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  createdByChanging(value: string, unsetDependents: boolean = true) {}
  
  createdByChanged(value: string, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  createdDateChanging(value: Date, unsetDependents: boolean = true) {}
  
  createdDateChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  createdDateLessThanChanging(value: Date, unsetDependents: boolean = true) {}
  
  createdDateLessThanChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  createdDateLessThanOrEqualToChanging(value: Date, unsetDependents: boolean = true) {}
  
  createdDateLessThanOrEqualToChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  createdDateGreaterThanChanging(value: Date, unsetDependents: boolean = true) {}
  
  createdDateGreaterThanChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  createdDateGreaterThanOrEqualToChanging(value: Date, unsetDependents: boolean = true) {}
  
  createdDateGreaterThanOrEqualToChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  maintenanceByChanging(value: string, unsetDependents: boolean = true) {}
  
  maintenanceByChanged(value: string, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  maintenanceDateChanging(value: Date, unsetDependents: boolean = true) {}
  
  maintenanceDateChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  maintenanceDateLessThanChanging(value: Date, unsetDependents: boolean = true) {}
  
  maintenanceDateLessThanChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  maintenanceDateLessThanOrEqualToChanging(value: Date, unsetDependents: boolean = true) {}
  
  maintenanceDateLessThanOrEqualToChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  maintenanceDateGreaterThanChanging(value: Date, unsetDependents: boolean = true) {}
  
  maintenanceDateGreaterThanChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  maintenanceDateGreaterThanOrEqualToChanging(value: Date, unsetDependents: boolean = true) {}
  
  maintenanceDateGreaterThanOrEqualToChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  maintenanceTypeLoadSelectionList() {
    this.refCodeStorage.getDomainElements('MAINTENANCE_TYPE').subscribe(
      data => {
        this.maintenanceTypeSelectionList = data;
      }
    );
  }

  maintenanceTypeChanging(value: string, unsetDependents: boolean = true) {}
  
  maintenanceTypeChanged(value: string, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  disabledTooltip(element) {
    if (!element) {
      return true;
    }
    return element.valid || !element.touched;
  }

  get assetMaintenanceId() {
    return this.searchForm && this.searchForm.get('assetMaintenanceId');
  }

  get asset() {
    return this.searchForm && this.searchForm.get('asset');
  }

  get assetId() {
    return this.searchForm && this.searchForm.get('assetId');
  }

  get assetIdLessThan() {
    return this.searchForm && this.searchForm.get('assetIdLessThan');
  }
  
  get assetIdLessThanOrEqualTo() {
    return this.searchForm && this.searchForm.get('assetIdLessThanOrEqualTo');
  }
  
  get assetIdGreaterThan() {
    return this.searchForm && this.searchForm.get('assetIdGreaterThan');
  }
  
  get assetIdGreaterThanOrEqualTo() {
    return this.searchForm && this.searchForm.get('assetIdGreaterThanOrEqualTo');
  }

  get comments() {
    return this.searchForm && this.searchForm.get('comments');
  }

  get createdBy() {
    return this.searchForm && this.searchForm.get('createdBy');
  }

  get createdDate() {
    return this.searchForm && this.searchForm.get('createdDate');
  }

  get createdDateLessThan() {
    return this.searchForm && this.searchForm.get('createdDateLessThan');
  }
  
  get createdDateLessThanOrEqualTo() {
    return this.searchForm && this.searchForm.get('createdDateLessThanOrEqualTo');
  }
  
  get createdDateGreaterThan() {
    return this.searchForm && this.searchForm.get('createdDateGreaterThan');
  }
  
  get createdDateGreaterThanOrEqualTo() {
    return this.searchForm && this.searchForm.get('createdDateGreaterThanOrEqualTo');
  }

  get maintenanceBy() {
    return this.searchForm && this.searchForm.get('maintenanceBy');
  }

  get maintenanceDate() {
    return this.searchForm && this.searchForm.get('maintenanceDate');
  }

  get maintenanceDateLessThan() {
    return this.searchForm && this.searchForm.get('maintenanceDateLessThan');
  }
  
  get maintenanceDateLessThanOrEqualTo() {
    return this.searchForm && this.searchForm.get('maintenanceDateLessThanOrEqualTo');
  }
  
  get maintenanceDateGreaterThan() {
    return this.searchForm && this.searchForm.get('maintenanceDateGreaterThan');
  }
  
  get maintenanceDateGreaterThanOrEqualTo() {
    return this.searchForm && this.searchForm.get('maintenanceDateGreaterThanOrEqualTo');
  }

  get maintenanceType() {
    return this.searchForm && this.searchForm.get('maintenanceType');
  }


}



